import dayjs from "dayjs";
import { motion } from "framer-motion";
import { useState } from "react";


//STYLES
import { Container } from "./style";

//APP
import { colorInsumos } from "../meta";
import { leadZero, transition_default } from "../../../../../../../utils";
import { estruturaListarInsumos } from "./meta";
import { Item__Atividades, Item__UnidadeMedida } from "../../../../../../../services/atividades/GET";
import { DetalhesInsumosSaida, totalizarInsumoTalhao } from "../../../meta/obter_dados";

//COMPONENTS
import { RowItem } from "../../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../../Components/CustomUi/table/rowTable";
import { Accordion } from "../../../../../../../Components/CustomUi/accordion";
import { BodyTable } from "../../../../../../../Components/CustomUi/table/bodyTable";
import { HeaderTable } from "../../../../../../../Components/CustomUi/table/headerTable";
import { Item__EquipeCliente } from "../../../../../../../services/Equipe/GET";
import { Tag, Tooltip } from "antd";

//PROPS
interface Props {
    nome_insumo: string;
    quantidade_normalizada: number;
    quantidade_convertida: number;
    medida_normalizada: string;
    list_talhoes_insumos: DetalhesInsumosSaida[];
    data_unidades_medida: Item__UnidadeMedida[];
    tipo_selecionada: string | 'Executados' | 'Planejados';
    data_equipe_cliente: Item__EquipeCliente[];
}

export const ModalDetalhesInsumos: React.FC<Props> = ({ nome_insumo, quantidade_normalizada, quantidade_convertida,
    medida_normalizada, list_talhoes_insumos, data_unidades_medida, tipo_selecionada, data_equipe_cliente }) => {
    //STATES
    const [open_accordion, setOpen_accordion] = useState<number>(null);

    return (
        <Container>
            <motion.button
                className="Container__main_bar"
                initial={{ width: 0 }}
                animate={{ width: '100%' }}
                transition={{ ...transition_default, delay: 0.1 }}
                whileTap={{ scale: 0.95 }}
                style={{
                    background: colorInsumos(quantidade_normalizada).bg,
                    minWidth: 220
                }}>

                <span className="Container__main_bar__item__name" style={{ color: colorInsumos(quantidade_normalizada).color }}>
                    {String(nome_insumo).toLowerCase()}
                </span>

                <span className="Container__main_bar__item__size">
                    {(quantidade_convertida)} {medida_normalizada}
                </span>
            </motion.button>

            {(list_talhoes_insumos ?? []).map(({ lista_atividades, nome_talhao, nome_propriedade, porcentagem_insumo, totalizar_qtd_insumos, cod_talhao, unidade_medida, cod_insumo }) => {
                let tabela_atividades = (estruturaListarInsumos(lista_atividades, data_unidades_medida, data_equipe_cliente) ?? []);
                return (
                    <Accordion
                        label={<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'left'
                        }}>
                            <span style={{ fontWeight: 600, margin: 0 }}>{nome_talhao}</span>
                            <span style={{ fontWeight: 600, fontSize: 11, color: 'var(--primary-color)', margin: 0 }}>{nome_propriedade}</span>
                        </div>}
                        open={open_accordion === cod_talhao}
                        trigger={open_accordion === cod_talhao ? () => setOpen_accordion(null) : () => setOpen_accordion(cod_talhao)}
                        extra={
                            <Bar
                                nome_insumo={porcentagem_insumo + "%"}
                                quantidade={totalizar_qtd_insumos}
                                medida={unidade_medida}
                                width={porcentagem_insumo}
                                qtd_atividades={tabela_atividades?.length ?? 0}
                            />
                        }
                        single
                    >
                        <BodyTable>
                            <HeaderTable
                                itens={[
                                    { valor: 'Atividade', width: 200 },
                                    { valor: tipo_selecionada === 'Executados' ? 'Operador' : 'Operadores', width: 190 },
                                    { valor: 'Área', width: 100 },
                                    { valor: 'Data', width: 100 },
                                    { valor: 'Tipo', width: 100 },
                                    { valor: 'Dosagem', width: 100 },
                                    { valor: 'Quantidade', width: 130 },
                                ]}
                            />
                        </BodyTable>
                        {(tabela_atividades ?? []).map(({ descricao, nome_operador_executada, calculo_dosagem,
                            area, data, quantidade, nome_medida, nome_operadores_planejada, dosagem, tipo_uso }) => {
                            return (
                                <RowTable style={{ height: 75 }} >
                                    <RowItem width={200} style={{ fontWeight: 600, lineHeight: 1.2 }}>
                                        {descricao}
                                    </RowItem>
                                    <RowItem width={190} style={{ textTransform: 'capitalize' }}>
                                        <div>
                                            {tipo_selecionada === 'Executados' && (<Tag>{String(nome_operador_executada).toLowerCase()}</Tag>)}

                                            {tipo_selecionada === 'Planejados' && (
                                                (nome_operadores_planejada ?? []).map((nome_operador) => {
                                                    return (
                                                        <Tag style={{ marginTop: 3 }}>
                                                            {String(nome_operador)?.toLowerCase()}
                                                        </Tag>
                                                    )
                                                })
                                            )}
                                        </div>
                                    </RowItem>
                                    <RowItem width={100}>
                                        {area} ha
                                    </RowItem>
                                    <RowItem width={100}>
                                        {dayjs(data)?.format("DD/MM/YY")}
                                    </RowItem>
                                    <RowItem width={100} style={{ wordBreak: "break-word", fontSize: 12 }}>
                                        {tipo_uso}
                                    </RowItem>
                                    <RowItem width={100} style={{ flexDirection: 'column' }}>
                                        {dosagem}
                                        {calculo_dosagem && <small><b>({calculo_dosagem})</b></small>}
                                    </RowItem>
                                    <RowItem width={130}>
                                        {quantidade} {nome_medida}
                                    </RowItem>
                                </RowTable>
                            )
                        })}
                    </Accordion>
                )
            })}


        </Container>
    )
};


//PROPS
interface PropsBar {
    nome_insumo: string;
    quantidade: number;
    medida: string;
    width: number;
    qtd_atividades: number;
}

const Bar: React.FC<PropsBar> = ({ nome_insumo, quantidade, medida, width, qtd_atividades }) => {
    return (
        <div style={{ width: 450, minWidth: 450, display: 'flex', alignItems: 'center', gap: 5, height: 30, background: 'rgba(213,213,213,0.2)', borderRadius: 4 }}>
            <Tooltip title="Quantidade de atividades que utilizam esse insumo">
                <div className="Container__qtd" style={{
                    border: `2px solid ${colorInsumos(quantidade).bg}`,
                    color: 'var(--primary-color)'
                }}>
                    {leadZero(qtd_atividades)}
                </div>
            </Tooltip>

            <Tooltip title="Percentual do total do insumo aplicado neste talhão.">
                <motion.button
                    className="Container__main_bar"
                    initial={{ width: 0 }}
                    animate={{ width: (width * 450) / 100 }}
                    transition={{ ...transition_default, delay: 0 }}
                    style={{
                        background: colorInsumos(quantidade).bg,
                        minWidth: medida === 'M de sementes' || medida === 'de sementes' ? 210 : 150
                    }}>

                    <span className="Container__main_bar__item__name" style={{ color: colorInsumos(quantidade).color, minWidth: 45 }}>{String(nome_insumo).toLowerCase()}</span>

                    <span className="Container__main_bar__item__size">
                        {(quantidade)} {medida}
                    </span>
                </motion.button>
            </Tooltip>
        </div>
    )
}